/**
 * AI 选课 · 后台内容审核（家长评价 / 品牌宣传短视频）
 *
 * ⚠️ 这两组接口是「AI 推课」链路上最后补的一环。此前家长能提交评价、教练能上传视频，
 * 但**没有任何后台入口能把它们变成可展示状态**，导致 H5 首页「家长怎么说」与视频位
 * 永远是空的。见后端 AiCourseAuditController 类注释。
 */
import request from '../utils/request';

const JSON_HEADER = {
    'Content-Type': 'application/json;charset=UTF-8'
};

/** 家长评价审核列表（含待审 / 通过 / 驳回） */
export const reviewAuditList = (param) => {
    return request({
        url: '/sys/aiCourseAudit/review/list',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(param),
        headers: JSON_HEADER
    });
};

/** 审核家长评价：auditState 1=通过 2=驳回（驳回必须带 auditRemark） */
export const reviewAudit = (param) => {
    return request({
        url: '/sys/aiCourseAudit/review/audit',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(param),
        headers: JSON_HEADER
    });
};

/** 宣传短视频审核列表（含待审 / 已发布 / 驳回 / 已下线） */
export const videoAuditList = (param) => {
    return request({
        url: '/sys/aiCourseAudit/video/list',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(param),
        headers: JSON_HEADER
    });
};

/** 审核短视频：auditState 1=发布 2=驳回 3=下线 */
export const videoAudit = (param) => {
    return request({
        url: '/sys/aiCourseAudit/video/audit',
        method: 'POST',
        dataType: 'json',
        data: JSON.stringify(param),
        headers: JSON_HEADER
    });
};

/** 待审数量（评价 + 视频），用于菜单红点 / 页面顶部提醒 */
export const pendingCount = () => {
    return request({
        url: '/sys/aiCourseAudit/pendingCount',
        method: 'GET'
    });
};
